<template>
  <div>
    <br />

    <!-- <vue-action-buttons :buttons="actionButtons">

      <template #cell-button name="{ row }">
        <span class="px-2 py-1 rounded " v-show="$userRole != 'Magasinier'"
          >
          
        </span>
      </template>
</vue-action-buttons> -->

    <vue-action-buttons :buttons="actionButtons" />



    <vue-order-details :order="history" :reference="$route.params.reference" />

    <br>

    <vue-data-table v-if="history.historyItems" :headers="headers" :data="history.historyItems" :items-per-page="10"
      :buttons="buttons" :summableColumns="summableColumns">


      <!-- Price -->
      <template #cell-priceTTC="{ row }">
        <div>
          <span :class="{ 'text-decoration-line-through text-danger': row.has_changes && row.priceTTC_diff !== 0 }">
            {{ formatCurrency(row.priceTTC) }}
          </span>
          <span v-if="row.has_changes && row.priceTTC_diff !== 0" class="text-success ms-2">
            → {{ formatCurrency(row.current_priceTTC) }}
            <span v-if="row.priceTTC_diff > 0" class="text-danger">(+{{ formatCurrency(row.priceTTC_diff) }})</span>
            <span v-else class="text-success">({{ formatCurrency(row.priceTTC_diff) }})</span>
          </span>
        </div>
      </template>


      <template #cell-quantity="{ row }">
        <div>
          <span :class="{ 'text-decoration-line-through text-danger': row.has_changes && row.quantity_diff !== 0 }">
            {{ row.quantity }}
          </span>
          <span v-if="row.has_changes && row.quantity_diff !== 0" class="text-success ms-2">
            → {{ row.current_quantity }}
            <span v-if="row.quantity_diff > 0" class="text-danger">(+{{ row.quantity_diff }})</span>
            <span v-else class="text-success">({{ row.quantity_diff }})</span>
          </span>
        </div>
      </template>
      <!-- Total Price -->
      <template #cell-totalPriceTTC="{ row }">
        <div>
          <span
            :class="{ 'text-decoration-line-through text-danger': row.has_changes && row.totalPriceTTC_diff !== 0 }">
            {{ formatCurrency(row.totalPriceTTC) }}
          </span>
          <span v-if="row.has_changes && row.totalPriceTTC_diff !== 0" class="text-success ms-2">
            → {{ formatCurrency(row.current_totalPriceTTC) }}
            <span v-if="row.totalPriceTTC_diff > 0" class="text-danger">(+{{ formatCurrency(row.totalPriceTTC_diff)
              }})</span>
            <span v-else class="text-success">({{ formatCurrency(row.totalPriceTTC_diff) }})</span>
          </span>
        </div>
      </template>


      <!-- Created By -->
      <template #cell-userFullName="{ row }">
        <div>
          <div v-if="row.updatedBy">
            <div>{{ row.updatedBy.name || 'System' }}</div>
            <small v-if="row.current_updatedBy" class="text-muted">
              Actuel: {{ row.current_updatedBy.name }}
            </small>
          </div>
        </div>
      </template>



      <!-- Footer for Total Price -->
      <template #footer-totalPriceTTC="{ column, sum }">
        <div>
          <span v-if="history.newTotalPriceTTC != history.totalPriceTTC"
            :class="{ 'text-decoration-line-through text-danger': history.newTotalPriceTTC != history.totalPriceTTC }">
            {{ formatCurrency(parseFloat(history.totalPriceTTC) )}}
          </span>
          <span v-if="history.newTotalPriceTTC != history.totalPriceTTC" class="text-success ms-2">
            → {{ formatCurrency(parseFloat(history.newTotalPriceTTC)) }}
            <span v-if="(history.newTotalPriceTTC - history.totalPriceTTC) > 0" class="text-danger">
              (+ {{ formatCurrency(parseFloat(history.newTotalPriceTTC) - parseFloat(history.totalPriceTTC)) }} ) 
            </span>
            <span v-else class="text-success">
              ({{ formatCurrency(parseFloat(history.newTotalPriceTTC) - parseFloat(history.totalPriceTTC)) }})
            </span>
          </span>
          <span v-if="history.newTotalPriceTTC == history.totalPriceTTC" class="fw-bold text-success">
            {{ formatCurrency(parseFloat(history.newTotalPriceTTC)) }} 
          </span>
        </div>
      </template>

      <!-- Footer for Quantity -->
      <template #footer-quantity="{ column, sum }">
        <div>
          <span v-if="history.newTotalQuantity != history.totalQuantity"
            :class="{ 'text-decoration-line-through text-danger': history.newTotalQuantity != history.totalQuantity }">
            {{ history.totalQuantity }}
          </span>
          <span v-if="history.newTotalQuantity != history.totalQuantity" class="text-success ms-2">
            → {{ sum }}
            <span v-if="(sum - history.totalQuantity) > 0" class="text-danger">
              (+{{ (parseFloat(sum) - parseFloat(history.totalQuantity)) }}) 
            </span>
            <span v-else class="text-success">
              ({{ (parseFloat(sum) - parseFloat(history.totalQuantity)) }}) 
            </span>
          </span>
          <span v-if="history.newTotalQuantity == history.totalQuantity" class="fw-bold text-primary">
            {{ sum }}
          </span>
        </div>
      </template>


    </vue-data-table>
    <br />
    <br />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      headers: [
        { field: 'itemFullName', label: 'Désignation', class: '' },
        { field: 'priceTTC', label: 'Prix', class: 'fw-bold' },
        { field: 'quantity', label: 'Quantité', class: 'fw-bold' },
        { field: 'totalPriceTTC', label: ' Total ', class: 'fw-bold' },
        { field: 'userFullName', label: 'Créer par', class: '' },
      ],
      // Button actions
      buttons: [

      ],

      summableColumns: [
        { field: 'totalPriceTTC', class: 'fw-bold' },
        { field: 'quantity', class: 'fw-bold' },
      ],
      // Columns to summarize

      actionButtons: [

        {
          label: "Actualiser",
          class: "btn btn-outline-dark",
          icon: "bi bi-arrow-clockwise",
          action: this.refresh,
        },
      ],
      reference: this.$route.params.reference
    };
  },

  async mounted() {
    await this.$store.dispatch("history/fetchOrderHistory", this.$route.params.reference);
  },
  computed: {
    ...mapGetters("history", {
      history: "getOrderHistory",
    }),

    
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("history/fetchOrderHistory", this.$route.params.reference);
    },
    formatCurrency(value) {
      if (isNaN(value) || value === null || value === undefined) return 'N/A';
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'MAD'
      }).format(value);
    },

    formatCurrencyDiff(value) {
      if (value > 0) return `+${this.formatCurrency(value)}`;
      return this.formatCurrency(value);
    },

    formatNumberDiff(value) {
      if (value > 0) return `+${value}`;
      return value;
    },

  },
};
</script>
